module.exports = __webpack_public_path__ + "static/media/restaurant.015fabf4.jpeg";